import React, { Component } from 'react';
import Table from '../components/indicators/IndicatorTable/Index'
import WebpackerReact from 'webpacker-react';

class IndicatorTableIndex extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            isLoaded: true,
        }
    }

    componentDidMount(){
        this.loadData();
    }

    updateStateLoad = (state) => {
        this.setState({ isLoaded: state })
    } 

    loadData = () => {
        fetch(`/indicator/get_indicator_tables/${this.props.type}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
          this.setState({
            data: data.data,
            isLoaded: false
          });
        });
    }


    render() {
        return (
            <React.Fragment>
                <Table
                    updateStateLoad={this.updateStateLoad}
                    loadData={this.loadData}
                    data={this.state.data}
                    estados={this.props.estados}
                    isLoaded={this.state.isLoaded}
                    type={this.props.type}
                    cargos={this.props.cargos}
                />
            </React.Fragment>
        );
    }
}


export default IndicatorTableIndex;
WebpackerReact.setup({ IndicatorTableIndex });